module.exports = __webpack_public_path__ + "static/media/person.026dd445.png";